import React from 'react';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    makeStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useGetProsjektSkjemaTypesQuery } from '../../../services/rtkApi';
import { translateProsjektSkjemaType } from '../../../utils';
import { LocalLoader } from '@klp/design/Loader';

const useStyles = makeStyles((theme) => ({
    formField: {
        '& .MuiTypography-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
}));

type ProsjektSkjemaTypeSelectProps = {
    value?: number;
    touched?: boolean;
    error?: string;
    onChange: (value: number) => void;
};

export const ProsjektSkjemaTypeSelect: React.FC<
    ProsjektSkjemaTypeSelectProps
> = ({ value, touched, error, onChange }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { data: prosjektSkjemaTypes, isLoading } =
        useGetProsjektSkjemaTypesQuery();

    const skjemaTypeEntries = prosjektSkjemaTypes
        ? Object.entries(prosjektSkjemaTypes)
        : [];

    const handleProsjektSkjemaTypeChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const selectedId = Number(event.target.value);
        if (!isNaN(selectedId)) {
            onChange(selectedId);
        }
    };

    return (
        <LocalLoader isLoading={isLoading}>
            <FormControl
                component="fieldset"
                error={touched && !!error}
                fullWidth={true}
                margin="normal"
                required={true}
            >
                <FormLabel component="legend" className={classes.formField}>
                    {t('project.opprettProsjekt.prosjektskjematype.label')}
                </FormLabel>
                <RadioGroup
                    row={true}
                    value={value?.toString() ?? ''}
                    onChange={handleProsjektSkjemaTypeChange}
                >
                    {skjemaTypeEntries.map(([typeName, typeId]) => (
                        <FormControlLabel
                            key={typeId}
                            value={typeId.toString()}
                            control={<Radio />}
                            label={translateProsjektSkjemaType(typeName)}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </LocalLoader>
    );
};
